var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquareCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "square-check",
    d: "M2.286,33.143a1.142,1.142,0,0,0-1.143,1.143V45.714a1.142,1.142,0,0,0,1.143,1.143H13.714a1.142,1.142,0,0,0,1.143-1.143V34.286a1.142,1.142,0,0,0-1.143-1.143ZM0,34.286A2.288,2.288,0,0,1,2.286,32H13.714A2.288,2.288,0,0,1,16,34.286V45.714A2.288,2.288,0,0,1,13.714,48H2.286A2.288,2.288,0,0,1,0,45.714Zm11.832,3.832L7.261,42.689a.573.573,0,0,1-.807,0L4.168,40.4a.571.571,0,0,1,.807-.807l1.882,1.882,4.168-4.168a.571.571,0,0,1,.807.807Z",
    transform: "translate(0 -32)",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquareCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/square-check.bd6e8d39ab9603383ffbcb9215dc9de2.svg";